import request from '@/utils/request'

export function getInitBoardUsers(data) {
  return request({
    url: 'get/initboard/users',
    method: 'post',
    params: data
  })
}

export function addInitBoardUser(data) {
  return request({
    url: 'add/initboard/user',
    method: 'post',
    params: data
  })
}

export function removeInitBoardUser(data) {
  return request({
    url: 'remove/initboard/user',
    method: 'post',
    params: data
  })
}
